import gsap from 'gsap';
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-collection-list-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            const target = slider.querySelector('[data-collection-list-slider-target]');
            new Swiper(target, {
                modules: [Navigation],
                slidesPerView: 2.5,
                spaceBetween: 24,
                breakpoints: {
                    500: {
                        slidesPerView: 3.5
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 34
                    },
                    1024: {
                        slidesPerView: 5
                    },
                    1280: {
                        slidesPerView: 6
                    },
                    1440: {
                        slidesPerView: 7
                    }
                },
                navigation: {
                    nextEl: slider.querySelector('[data-collection-list-slider-next]'),
                    prevEl: slider.querySelector('[data-collection-list-slider-prev]'),
                }
            });
        });
    }

}